if (!customElements.get('store-appointment-drawer')) {
  customElements.define(
    'store-appointment-drawer',
    class StoreAppointmentDrawer extends window.BAO.CustomElement() {
      get info () {
        return this._info
      }

      set info (val) {
        this._info = val
      }

      get timeId () {
        return this._timeId
      }

      set timeId (val) {
        this._timeId = val

        this.els['info-container'].element.hidden = false
        this.els['info-container'].element.scrollIntoView({
          behavior: 'smooth',
        })
      }

      get hasBeenCompleted () {
        return this._hasBeenCompleted
      }

      set hasBeenCompleted (val) {
        this._hasBeenCompleted = val

        this.externalEls.submit.element.classList.toggle(
          'btn-Button-primary',
          val
        )
        this.externalEls.submit.element.classList.toggle(
          'btn-Button-secondary',
          !val
        )

        this.externalEls.submit.element.disabled = !val

        this.externalEls['submit-text'].element.textContent = val
          ? this.externalEls.submit.element.dataset.activeText
          : this.externalEls.submit.element.dataset.inactiveText
      }

      get examTypeId () {
        return this._examTypeId
      }

      set examTypeId (val) {
        this._examTypeId = val

        this._locationData = []
        this._dayData = []
        this._timeData = []

        this.resetLocation()

        this.getLocations(this.examTypeId).then(r => {
          this._locationData = r.channels

          const options = this.getLocationOptionsFromResponse(r)

          this.renderOptions(this.els.location.element, options)

          const locationExists = options.some(
            option => option.label === this.getAttribute('current')
          )

          if (locationExists) {
            this.els.location.element.dispatchEvent(
              new Event('change', { bubbles: true })
            )
          }

          this.els['location-block'].element.hidden = false
          this.els['location-block'].element.scrollIntoView({
            behavior: 'smooth',
          })
        })
      }

      get locationId () {
        return this._locationId
      }

      set locationId (val) {
        this._locationId = val

        if (!this.location) {
          this.resetLocation()

          return
        }

        this.setLocation()
      }

      constructor () {
        super()
        this.els['exam-type'].elements.forEach(el => (el.checked = false))
        this._accessKey = window.atob(
          'Rlc3bU52LUR6VE1KIWxMSUk/bWF1c1c5dkF1TUdxZnZ3Ti1XWWthMQ=='
        )
        this._locationData = []
        this._dayData = []
        this._timeData = []
        this._locationId = null
        this._timeId = null
        this._hasBeenCompleted = false
        this._examTypeId = null
        this._info = { name: '', email: '', phone: '' }
      }

      setupListeners () {
        this.handleExamTypeChange = this.handleExamTypeChange.bind(this)
        this.handleLocationChange = this.handleLocationChange.bind(this)
        this.handleDaySelection = this.handleDaySelection.bind(this)
        this.handleTimeChange = this.handleTimeChange.bind(this)
        this.handleInfoChange = this.handleInfoChange.bind(this)
        this.handleSubmission = this.handleSubmission.bind(this)

        this.els['exam-type'].elements.forEach(el => {
          this.listeners.add(el, 'change', this.handleExamTypeChange)
        })

        this.listeners.add(
          this.els.location.element,
          'change',
          this.handleLocationChange
        )
        this.listeners.add(this, 'dateselect', this.handleDaySelection)
        this.listeners.add(
          this.els.time.element,
          'change',
          this.handleTimeChange
        )
        this.listeners.add(
          this.els['info-container'].element,
          'input',
          this.handleInfoChange
        )
        this.listeners.add(
          this.externalEls.submit.element,
          'click',
          this.handleSubmission
        )
      }

      handleExamTypeChange (e) {
        this.hasBeenCompleted = false
        this.examTypeId = parseInt(e.target.value, 10)
      }

      handleTimeChange (e) {
        this.hasBeenCompleted = false
        this.timeId = parseInt(e.target.value, 10)
      }

      handleInfoChange (e) {
        const fields = ['email', 'name', 'phone']

        const isNameEmailOrPhone = fields.includes(e.target.name)
        if (!isNameEmailOrPhone) return

        this.info = {
          ...this.info,
          [e.target.name]: e.target.value,
        }

        const phonePattern = /^((\+44)|(0)) ?\d{4} ?\d{6}$/
        if (e.target.name === 'phone') {
          if (phonePattern.test(e.target.value)) {
            this.info.phone = e.target.value
            this.showOriginalLabel(e)
          } else {
            this.showLabelError(e)
          }
        }

        const emailPattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
        if (e.target.name === 'email') {
          if (emailPattern.test(e.target.value)) {
            this.info.email = e.target.value
            this.showOriginalLabel(e)
          } else {
            this.showLabelError(e)
          }
        }

        if (this.customer.isLoggedIn) {
          const loggedInFields = fields.filter(field =>
            ['phone'].includes(field)
          )

          this.hasBeenCompleted = loggedInFields.every(field => {
            if (field === 'email' && !emailPattern.test(this.info[field])) {
              return false
            }

            if (field === 'phone' && !phonePattern.test(this.info[field])) {
              return false
            }

            return this.info[field] !== ''
          })

          return
        }

        this.hasBeenCompleted = fields.every(field => {
          if (field === 'email' && !emailPattern.test(this.info[field])) {
            return false
          }

          if (field === 'phone' && !phonePattern.test(this.info[field])) {
            return false
          }

          return this.info[field] !== ''
        })
      }

      showOriginalLabel (e) {
        e.target.classList.remove('error')

        if (e.target.labels) {
          e.target.labels[0].classList.remove('hidden')
          e.target.labels[1].classList.remove('visible')
          e.target.labels[1].classList.add('hidden')
        }
      }

      showLabelError (e) {
        e.target.classList.add('error')

        if (e.target.labels) {
          e.target.labels[1].classList.remove('hidden')
          e.target.labels[1].classList.add('visible')
          e.target.labels[0].classList.add('hidden')
        }
      }

      async handleSubmission () {
        this.loading = true

        const body = {
          id: window.theme.customer.id,
          slot: this._timeId,
          length: this._examTypeId,
          phone: this.info.phone,
        }

        if (this.customer.isLoggedIn === false) {
          body.name = this.info.name
          body.email = this.info.email
        }

        const queryString = window.location.search;
        console.log(queryString);
        const urlParams = new URLSearchParams(queryString);
        const source = urlParams.get('source');
        console.log(source);
        
        // Log the window url 
        var xhttp = new XMLHttpRequest();
        xhttp.onreadystatechange = function() {
            if (this.readyState == 4 && this.status == 200) {
               // Typical action to be performed when the document is ready:
               console.log(xhttp.responseText);
            }
        };
        xhttp.open("GET", "https://oms.cubittsadmin.com/logeyetestbooking?source="+source, true);
        xhttp.send();

        if(source=="bakery") {
            body.name=body.name+"(BAKERY PROM)";
        }
        
        await window.BAO.CubittsAPI.eyeExamBooking(body)

        this.loading = false

        Array.from(
          this.querySelectorAll('.str-AppointmentDrawer_Block')
        ).filter(el => {
          el.hidden = el !== this.els.confirmation.element
        })

        this.externalEls.submit.element.hidden = true
      }

      getLocationOptionsFromResponse (response) {
        return response.channels.map(channel => ({
          value: channel.id,
          label: channel.longName,
          selected: channel.longName === (this.getAttribute('current') || ''),
        }))
      }

      renderOptions (el, options) {
        Array.from(el.options).forEach((option, index) => {
          if (index === 0) return

          // We always want to remove the 2nd index because the list shrinks as we remove it we can't remove the index it was at when the loop started
          el.options.remove(1)
        })

        options.forEach(({ label, value, selected = false } = {}) =>
          el.options.add(new Option(label, value, false, selected))
        )
      }

      handleLocationChange (e) {
        this.hasBeenCompleted = false
        this.locationId = parseInt(e.target.value, 10)
      }

      async handleDaySelection (e) {
        this.hasBeenCompleted = false
        // $YEAR$-$MONTH$-$DAY$
        const [year, month, day] = e.target.value.split('-')
        const dayDate = new Date(
          parseInt(year, 10),
          parseInt(month, 10) - 1,
          parseInt(day, 10)
        )
        const dayData = this._dayData.find(d => {
          const [year, month, day] = d.date.split('-')
          const dD = new Date(
            parseInt(year, 10),
            parseInt(month, 10) - 1,
            parseInt(day, 10)
          )

          return dD.getTime() === dayDate.getTime()
        })

        this._timeData = await this.getTime(dayData.id, this.examTypeId)
        this.renderOptions(
          this.els.time.element,
          this._timeData
            .map(time => ({
              label: time.slot,
              value: time.id,
            }))
            .sort((dateA, dateB) => {
              if (dateA.label > dateB.label) {
                return 1
              } else if (dateA.label < dateB.label) {
                return -1
              }

              return 0
            })
        )
        this.els['time-container'].element.hidden = false
        setTimeout(() => {
          this.els['time-container'].element.scrollIntoView({
            behavior: 'smooth',
          })
        }, 100)

        this.drawer.scroll({
          top: this.drawer.offsetHeight,
          left: 0,
          behavior: 'smooth',
        })
      }

      async getLocations (examTypeId) {
        this.loading = true

        const res = await window.BAO.CubittsAPI.eyeExamLocations(examTypeId)

        this.loading = false

        return res
      }

      async getLocationDays (locationId, examTypeId) {
        this.loading = true

        const res = await window.BAO.CubittsAPI.eyeExamLocationDays(
          locationId,
          examTypeId
        )

        this.loading = false

        return res
      }

      async getTime (dayId, examTypeId) {
        this.loading = true

        const res = await window.BAO.CubittsAPI.eyeExamTimes(dayId, examTypeId)

        this.loading = false

        return res
      }

      async setLocation () {
        this._dayData = await this.getLocationDays(
          this.locationId,
          this.examTypeId
        )

        this.els['store-line'].element.hidden = false
        this.els['store-title'].element.textContent = `${
          this.location.street
        }, ${this.location.phone}`
        this.els['store-map'].element.setAttribute(
          'href',
          this.location.mapLink
        )
        this.els['calendar'].element.hidden = false
        this.els['calendar'].element.scrollIntoView({ behavior: 'smooth' })

        this.els['date-picker'].element.setAvailableDays(
          this._dayData.map(dayData =>
            this.els['date-picker'].element.getDateFromString(dayData.date)
          )
        )
        this.els['date-picker'].element._renderCalendar()
      }

      resetLocation () {
        this._dayData = []

        this.els['store-line'].element.hidden = true
        this.els['store-title'].element.textContent = ''
        this.els['store-map'].element.removeAttribute('href')
        this.els['calendar'].element.hidden = true
        this.els['date-picker'].element._hasSelection = false
        this.els['time-container'].element.hidden = true
      }

      get location () {
        return this._locationData.find(l => l.id === this.locationId)
      }

      get drawer () {
        return this.closest('.drw-Drawer')
      }

      get customer () {
        return window.theme.customer
      }

      get loading () {
        return this._loading
      }

      set loading (val) {
        this._loading = val

        this.els.loading.element.classList.toggle(
          'str-AppointmentDrawer_Loading-active',
          val
        )
      }
    }
  )
}
